import { render, staticRenderFns } from "./BowText.vue?vue&type=template&id=c5aa29dc&"
import script from "./BowText.vue?vue&type=script&lang=js&"
export * from "./BowText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports